import React from 'react';
import { Container, Grid, Box, Typography, CircularProgress } from '@mui/material';
import { useDashboardData } from './dashboard/hooks/useDashboardData';
import MetricsGrid from './dashboard/components/MetricsGrid';
import VerificationChart from './dashboard/components/VerificationChart';
import GeographicChart from './dashboard/components/GeographicChart';
import QuickActions from './dashboard/components/QuickActions';
import ActivityFeed from './dashboard/components/ActivityFeed';
import VivLogo from './components/VivLogo';

const Dashboard = () => {
  const { data, loading, refreshData } = useDashboardData();

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '400px'
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!data) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h6" color="error">
          Failed to load dashboard data
        </Typography>
      </Box>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h4" fontWeight={700} color="text.primary">
          Dashboard
        </Typography>
        <VivLogo size={87} />
      </Box>

      <MetricsGrid metrics={data.metrics} onRefresh={refreshData} />

      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} lg={8}>
          <VerificationChart data={data.charts.verificationTrends} />
        </Grid>
        <Grid item xs={12} lg={4}>
          <QuickActions actions={data.quickActions} />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={12} lg={8}>
          <GeographicChart data={data.charts.geographic} />
        </Grid>
        <Grid item xs={12} lg={4}>
          <ActivityFeed activities={data.activities} />
        </Grid>
      </Grid>
    </Container>
  );
};

export default Dashboard;